import { service } from '@ember/service';
import Component from '@glimmer/component';

export default class AtomsLabelComponent extends Component {
  @service intl;

  get color() {
    return this.args.color || this.getColor();
  }

  get showZero() {
    if (!this.args.value) {
      return false;
    }
    if (this.args.showZero) {
      return true;
    } else {
      return this.args.value !== 0;
    }
  }

  getColor() {
    if (this.args.value > 0 && this.args.value < 3) {
      return 'blue';
    } else if (this.args.value > 2 && this.args.value < 5) {
      return 'yellow';
    } else if (this.args.value > 4) {
      return 'red';
    } else {
      return 'blue';
    }
  }

  get tooltipString() {
    if (this.args.value > 6) {
      let num_of_weeks = (this.args.value / 7).toFixed(0);
      return `${this.intl.t('dictionary.created')} ${num_of_weeks} week${num_of_weeks > 1 ? 's' : ''} ${this.intl.t(
        'dictionary.ago',
      )}`;
    } else {
      return `${this.intl.t('dictionary.created')} ${this.args.value} day${
        this.args.value > 1 ? 's' : ''
      } ${this.intl.t('dictionary.ago')}`;
    }
  }

  get labelString() {
    if (this.args.value > 6) {
      return `W`;
    } else {
      return this.args.value;
    }
  }

  get fontSize() {
    if (this.args.value > 6) {
      return 'text-[10px]';
    } else {
      return 'text-xs';
    }
  }
}
